/**
Copyright (C) 2019-2022, Infraclear Inc. All Rights Reserved.
*/

import { Navigate } from 'react-router-dom';
import { Route, Routes } from 'react-router-dom';
import { ROLES } from '../constants/commonConstants';
import { DashboardPage } from '../pages/dashboard/dashboard';
import { GuestSignUp } from '../pages/guestSignUp/guestSignUp';
import { HomePage } from '../pages/home/home';
import { ListApps } from '../pages/listApps/listApps';
import ListUsers from '../pages/listUsers/listUsers';
import { LoginPage } from '../pages/login/login';
import { SignUpForTrial } from '../pages/signUpTrial/signUpTrial';
import { SignUpForTrialDesktop } from '../pages/guestSignUp/signUpTrialDesktop';
import { UserEnrolmentTable } from '../pages/userEnrolment/userEnrolment';
import GuestGuardedRoute from './guestLoginGuard';
import LoginGuardedRoute from './loginrouteGuard';
import GuardedRoute from './routeGuard';
import { useEffect, useState } from 'react';
import { decryptUserData } from '../utils';
import SSO from '../pages/sso';
import LoginWithGoogle from '../pages/sso/loginWithGoogle';
import Config from '../pages/config';
import AdminClients from '../pages/admin/clients';
import AdminApiKeys from '../pages/admin/api-keys';
import AdminUsage from '../pages/admin/usage';
import AdminMcpSubscriptions from '../pages/admin/mcp-subscriptions';

const AppRoutes = () => {
  const [user, setUser] = useState<any | null>(null);

  useEffect(() => {
    decryptUserData()?.then((data) => {
      setUser(data);
    });
  }, [])

  return (
    <Routes>
      <Route path="/">
        {user?.id &&
          <Route
            path="*"
            element={ // used to redirect to applictions if undefined route enterred
              <Navigate to="applications" />
            }>
          </Route>
        }
        {!user?.id && !localStorage.getItem('u-info') &&
          <Route
            path="*"
            element={ // used to redirect to / if undefined route enterred
              <Navigate to="/" />
            }>
          </Route>
        }
        <Route exact path="/" element={
          <Navigate to="/login" />
        }
        />
        <Route path="/login" element={
          <LoginGuardedRoute>
            <LoginPage />
          </LoginGuardedRoute>
        } />
        <Route path="/signup" element={<SignUpForTrial />} />
        <Route path="/sso" element={<SSO />} />
        <Route path="/google" element={<LoginWithGoogle />} />
        <Route path="/free-trial-signup" element={<SignUpForTrial />} />
        <Route path="/trial_signup" element={
          <GuestGuardedRoute>
            <GuestSignUp />
          </GuestGuardedRoute>
        }
        />
        {/* Signup Redirection from public domain */}
        <Route path="/trial-signup" element={
          <GuestGuardedRoute>
            <GuestSignUp />
          </GuestGuardedRoute>
        }
        />
        <Route path="/trial-signup-desktop" element={<SignUpForTrialDesktop />} />
        {/* //{user?.id && */}
          <Route path="/" element={
          <GuardedRoute user={user}>
            <HomePage />
          </GuardedRoute>
        }>
          <Route path="users" >
            <Route index element={
              <GuardedRoute user={user} roleRequired={[ROLES.SUPER_ADMIN, ROLES.USER_MGMT_ADMIN, ROLES.SALES_REPRESENTATIVE]}>
                <ListUsers />
              </GuardedRoute>
            } />
            <Route path="usersEnrolment" >
              <Route index element={
                <GuardedRoute user={user} roleRequired={[ROLES.SUPER_ADMIN, ROLES.USER_MGMT_ADMIN, ROLES.SALES_REPRESENTATIVE]}>
                  <UserEnrolmentTable />
                </GuardedRoute>
              } />
            </Route>
          </Route>
          <Route path="config" >
            <Route index element={
              <GuardedRoute user={user} roleRequired={[ROLES.SUPER_ADMIN, ROLES.USER_MGMT_ADMIN, ROLES.SALES_REPRESENTATIVE]}>
                <Config />
              </GuardedRoute>
            } />
          </Route>
          <Route path="admin/clients" >
            <Route index element={
              <GuardedRoute user={user} roleRequired={[ROLES.SUPER_ADMIN]}>
                <AdminClients />
              </GuardedRoute>
            } />
          </Route>
          <Route path="admin/api-keys" >
            <Route index element={
              <GuardedRoute user={user} roleRequired={[ROLES.SUPER_ADMIN]}>
                <AdminApiKeys />
              </GuardedRoute>
            } />
          </Route>
          <Route path="admin/usage" >
            <Route index element={
              <GuardedRoute user={user} roleRequired={[ROLES.SUPER_ADMIN]}>
                <AdminUsage />
              </GuardedRoute>
            } />
          </Route>
          <Route path="admin/mcp-subscriptions" >
            <Route index element={
              <GuardedRoute user={user} roleRequired={[ROLES.SUPER_ADMIN]}>
                <AdminMcpSubscriptions />
              </GuardedRoute>
            } />
          </Route>
          {/* <Route path="stats" >
            <Route index element={
              <GuardedRoute roleRequired={[ROLES.SUPER_ADMIN]}>
                <Monitoring />
              </GuardedRoute>
            } />
          </Route> */}
          <Route path="/applications">
            <Route index element={
              <GuardedRoute user={user}>
                <ListApps />
              </GuardedRoute>
            } />
          </Route>
          <Route
            path="/dashboard"
            element={
              <GuardedRoute user={user}>
                <DashboardPage />
              </GuardedRoute>
            }
          />
          </Route>
        {/* } */}
      </Route>
    </Routes>
  )
};

export default AppRoutes


